export const container = (isMobile) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
  padding: isMobile ? "8px" : "16px",
  margin: "0 auto", 
  
});

export const card = (isMobile) => ({
  maxWidth: isMobile ? "90%" : "500px",
  width: "100%",
  flexGrow: 1,
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  padding: isMobile ? "8px" : "16px",
  boxShadow: 3,
  borderRadius: 2,
  margin: "0 auto", 
  backgroundColor: "rgba(0, 0, 0, 0.1)",
  backdropFilter: "blur(10px) "
});

export const slide = {
  transition: "all 0.5s ease",
};
